export class MemberFilterModel {
  firstName?: string;
  document?: string;
}
